import React, { useState, createContext, useEffect } from "react";
import axios, { AxiosResponse } from "axios";
import { useGlobalData } from "./GlobalContext";
import { useNotification } from "./Notification";
import { FAVORITESROUTE } from "../utils/APIRoutes";
import { FavoriteProps } from "../components/Bikes/Card";

export const FavoritesContext = createContext<{
  favorites: FavoriteProps[];
  setFavorites: Function;
}>({
  favorites: [],
  setFavorites: () => {},
});

export const FavoritesProvider = ({ children }: React.PropsWithChildren) => {
  const { user } = useGlobalData();
  const { addNotification } = useNotification();
  const [favorites, setFavorites] = useState<FavoriteProps[]>([]);

  useEffect(() => {
    if (user && user.role === "Cliente") {
      axios
        .get(FAVORITESROUTE, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.access_token}`,
          },
        })
        .then((response: AxiosResponse<FavoriteProps[]>) => {
          const data = response.data;
          setFavorites(data);
        })
        .catch((error) => {
          addNotification({
            type: "error",
            content: error.response.data?.message || error.message,
          });
        });
    }
  }, [user]);

  return (
    <FavoritesContext.Provider value={{ favorites, setFavorites }}>
      {children}
    </FavoritesContext.Provider>
  );
};
